import type { Deal } from "../types";
import type { DealPipeline } from "../deals/pipelines";
export type ProposalState = "draft" | "sent" | "approved";
export function canAssignProjectManager(pipeline: DealPipeline, stage: string) {
  const start = pipeline.stages.findIndex(
    (s) => s.value === pipeline.quoteWorkflow?.managerStage,
  );
  return (
    start >= 0 && pipeline.stages.findIndex((s) => s.value === stage) >= start
  );
}
export function validateQuoteMilestones(pipeline: DealPipeline) {
  const rule = quoteMilestones(pipeline);
  if (!rule) return;
  const sent = pipeline.stages.findIndex((s) => s.value === rule.sentStage),
    agreement = pipeline.stages.findIndex(
      (s) => s.value === rule.agreementStage,
    );
  if (sent < 0 || agreement < sent)
    throw new Error(
      `Воронка «${pipeline.label}»: выберите действующие этапы отправки и согласования КП в правильном порядке`,
    );
  if (
    rule.managerStage &&
    !pipeline.stages.some((s) => s.value === rule.managerStage)
  )
    throw new Error(
      `Воронка «${pipeline.label}»: этап назначения менеджера удалён`,
    );
}
export function quoteMilestones(pipeline: DealPipeline) {
  return (
    pipeline.quoteWorkflow ??
    (pipeline.value === "catalog"
      ? {
          sentStage: "catalog-proposal-sent",
          agreementStage: "catalog-contract",
        }
      : pipeline.value === "bureau"
        ? { sentStage: "bureau-proposal", agreementStage: "bureau-contract" }
        : undefined)
  );
}
export function requireQuoteStage(
  deal: Pick<Deal, "stage" | "quote_legacy" | "quote_state">,
  pipeline: DealPipeline,
) {
  if (deal.quote_legacy || pipeline.lostStages.includes(deal.stage)) return;
  const rule = quoteMilestones(pipeline);
  if (!rule) {
    if (deal.stage !== pipeline.stages[0]?.value)
      throw new Error("Сначала настройте этапы КП для этой воронки");
    return;
  }
  const index = pipeline.stages.findIndex((s) => s.value === deal.stage);
  const sent = pipeline.stages.findIndex((s) => s.value === rule.sentStage);
  const agreement = pipeline.stages.findIndex(
    (s) => s.value === rule.agreementStage,
  );
  if (sent < 0 || agreement < 0 || agreement < sent)
    throw new Error("Этапы КП в воронке требуют настройки");
  if (index >= agreement && deal.quote_state !== "approved")
    throw new Error("Для этого этапа требуется согласованное КП");
  if (
    index >= sent &&
    !["sent", "approved"].includes(deal.quote_state ?? "draft")
  )
    throw new Error("Сначала сохраните КП и отметьте отправку заказчику");
}
